const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
  'zh-CN': {
    currency: {
      style: 'currency',
      currency: 'CNY',
    },
  },
};
export default numberFormats;
